import { render, staticRenderFns } from "./ProductsListWithOutStock.vue?vue&type=template&id=0037de74&"
import script from "./ProductsListWithOutStock.vue?vue&type=script&lang=js&"
export * from "./ProductsListWithOutStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports